const startCase = str => {
  if (!str) return '';

  // First handle camelCase by adding spaces before capital letters
  const spacedStr = str.replace(/([A-Z])/g, ' $1');

  // Split by spaces and underscores, then capitalize each word
  return spacedStr
    .toLowerCase()
    .split(/[\s_]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export { startCase };
